module.exports = __webpack_public_path__ + "67ca532d3d7ae42ba4ab3a7b67d291b5.svg";